import React from "react";

export function BBishopIcon({ color = "#5F5955" }: { color?: string }) {
  return (
    <svg
      height="1em"
      width="1em"
      viewBox="0 0 105 147"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M52.4882 0.796539C44.5285 0.796539 38.0806 4.11874 38.0806 8.21575L43.8142 18.2315C-16.8472 71.485 22.2444 120.793 22.2444 120.793H82.7357C82.7357 120.793 109.381 88.0167 85.6195 47.0542L74.3187 65.298C71.7865 69.395 66.9033 70.9295 63.3694 68.7411C59.8356 66.5565 59.0343 61.4958 61.5666 57.4025L76.2576 33.6784C71.6516 28.1323 66.6046 22.9678 61.166 18.2353L66.8995 8.21953C66.8995 4.11874 60.4441 0.796539 52.4882 0.796539Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M52.4882 116.79C52.4882 116.79 17.9811 116.972 8.30173 122.913C1.77449 126.919 0.23244 136.708 1.12063 146.811H103.856C104.744 136.712 103.206 126.916 96.6747 122.909C86.9991 116.975 52.4882 116.79 52.4882 116.79Z"
        fill={color}
      />
    </svg>
  );
}
